export default "__VITE_ASSET__828dd864__"